import { Controller } from '@hotwired/stimulus';

import IMask from 'imask';

export default class InputMaskController extends Controller {
    static values = {
        min:              { type: Number, default: 0 },
        scale:            { type: Number, default: 2 },
        decimalSeparator: { type: String, default: '.' },
        groupingSymbol:   { type: String, default: ',' },
    };

    connect() {
        this.element.imask = IMask(this.element, {
            mask:               Number,
            signed:             false,
            mapToRadix:         ['.'],
            normalizeZeros:     true,
            padFractionalZeros: false,

            min:                this.minValue >= 0 ? this.minValue : null,
            scale:              this.scaleValue,
            radix:              this.decimalSeparatorValue,
            thousandsSeparator: this.groupingSymbolValue,
        });
    }
}
